// The 1–10 / 0–10 button row. overall-experience.tsx and aura.tsx each carry their own
// copy over there; this unit needs it on both of its own steps, so it is extracted once
// (PORTING.md U8) — the markup and classes are unchanged.
export function NumericRating({
  value,
  onChange,
  options,
  leftLabel,
  rightLabel,
}: {
  value: number | undefined;
  onChange: (value: number) => void;
  options: number[];
  leftLabel: string;
  rightLabel: string;
}) {
  return (
    <div className="flex flex-col gap-3">
      <div className="w-full overflow-x-auto">
        <div
          className="grid min-w-[520px] gap-2"
          style={{
            gridTemplateColumns: `repeat(${options.length}, minmax(0, 1fr))`,
          }}
        >
          {options.map((rating) => (
            <button
              key={rating}
              type="button"
              onClick={() => onChange(rating)}
              className={`aspect-square w-full rounded-lg border-2 font-bold transition-colors ${
                value === rating
                  ? 'border-primary bg-primary text-primary-foreground'
                  : 'border-border bg-transparent hover:border-primary/50'
              }`}
            >
              {rating}
            </button>
          ))}
        </div>
      </div>
      <div className="flex items-center justify-between text-muted-foreground text-sm">
        <span>{leftLabel}</span>
        <span>{rightLabel}</span>
      </div>
    </div>
  );
}
